import { apiClient } from '../api-client';
import { EMAIL_CHANNEL } from '../../api-endpoints/api-endpoints';
import { EmailChannelResponse, VerifySenderResponse } from '../../schema/org/email-channel.schema';

export const emailChannelService = {
  get: (): Promise<EmailChannelResponse> =>
    apiClient.get<EmailChannelResponse>(EMAIL_CHANNEL.get),

  update: (body: Record<string, unknown>): Promise<EmailChannelResponse> =>
    apiClient.patch<EmailChannelResponse>(EMAIL_CHANNEL.update, body),

  verifySender: (): Promise<VerifySenderResponse> =>
    apiClient.post<VerifySenderResponse>(EMAIL_CHANNEL.verifySender),

  confirmVerify: (token: string): Promise<{ ok: boolean; verified: boolean }> =>
    apiClient.get<{ ok: boolean; verified: boolean }>(`${EMAIL_CHANNEL.confirmVerify}?token=${token}`),
};
